import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './GetStartedInput.css'
import { AutocompleteSearch, Link, LinkIcon } from '../../components'
import config from '../../config'

@CSSModules(Styles)
export default class GetStartedInput extends Component {
  constructor(props){
    super(props)
    this.state = {}
  }
  render() {
    return (
      <div styleName='container-wrap'>
        <div styleName='container'>
          <div styleName='container-inner'>
            <div styleName='form-wrap'>

              <div styleName='tagline'>
                Find sustainably-invested mutual funds and ETFs
              </div>

              <div styleName='link-wrap'>
                <Link
                  to={config.routes.clean}
                  bigbutton
                  title={config.getStartedInput.title}
                >
                  {config.getStartedInput.label}
                  <LinkIcon faclass={config.getStartedInput.faclass} />
                </Link>
              </div>

              <br/>
              <br/>
              <br/>

              <div styleName='tagline'>
                Search for funds from your 401(k), retirement plan, or
                personal portfolio
              </div>

              <div styleName='autocomplete-wrap'>
                <AutocompleteSearch />
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}
